import useMyLibrary from "../../modules/user/hooks/use-my-library";
import './style.scss';

type Props = {}

const LibraryEmail: React.FC<Props> = () => {

    const {library} = useMyLibrary();

    return <>
        {library?.email && <div className="lib-email">
            <h3>Adres waszej biblioteki</h3>
            <p>
                {library.email}
            </p>
        </div>}
    </>
}

export default LibraryEmail;
